import { Box, CircularProgress } from '@mui/material';
import AddressMap from 'components/Maps/AddressMap';
import KlikAutocomplete from 'components/organisms/KlikAutocomplete';
import KlikMap from 'components/organisms/KlikMap';
import { useEffect, useState } from 'react';
import { GeocoderService } from 'services/mapService';
import { defaultMapCenter } from 'static/defaults';
import { Location } from 'types/map';

declare global {
    interface Window {
        google: any;
    }
}

interface IAddressMapProps {
    address: {
        fullAddress: string;
        latitude: number;
        longitude: number;
    };
    onAddressChange?: (address: { fullAddress: string; latitude: number; longitude: number }) => void;
}

const UserAddress = ({ address, onAddressChange }: IAddressMapProps) => {
    const [location, setLocation] = useState<Location>(defaultMapCenter);
    const [zoom, setZoom] = useState<number>(15);
    const [loadingCurrentLocation, setLoadingCurrentLocation] = useState<boolean>(false);

    const geocoderService = new GeocoderService();

    useEffect(() => {
        setLoadingCurrentLocation(true);
        const successCallback = position => {
            const { latitude, longitude } = position.coords;
            if (!address.fullAddress) {
                setLocation({ lat: latitude, lng: longitude });
                geocoderService.geocode(
                    { location: { lat: latitude, lng: longitude } },
                    (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                        if (results.length) {
                            let found = results.find(add => add.types.includes('street_address') || add.types.includes('route'));
                            if (!found) {
                                found = results[0];
                            }

                            onAddressChange({
                                fullAddress: found.formatted_address,
                                longitude: longitude,
                                latitude: latitude,
                            });
                        }
                    }
                );
            }
            setZoom(14);
            setLoadingCurrentLocation(false);
        };
        const errorCallback = e => {
            console.log(e);
            setLoadingCurrentLocation(false);
        };
        navigator.geolocation.getCurrentPosition(successCallback, errorCallback, {
            timeout: 5000,
            enableHighAccuracy: true,
        });
    }, []);

    useEffect(() => {
        if (address.fullAddress) {
            setLocation({ lat: address.latitude, lng: address.longitude });
        }
    }, [address]);

    return (
        <>
            {/* {map && <KlikAutocomplete address={address} onAddressChange={onAddressChange} />} */}
            <KlikAutocomplete address={address} onAddressChange={onAddressChange} />
            <Box mt={1} position="relative">
                <Box height={200} zIndex={99}>
                    {/* <KlikMap location={location} zoom={zoom} onClick={handleOnClick} onMapLoad={onMapLoad} /> */}
                    <AddressMap position={location} onAddressChange={onAddressChange} onPositionChange={setLocation} />
                </Box>
                {loadingCurrentLocation && (
                    <div
                        style={{
                            width: '100%',
                            height: '200px',
                            position: 'absolute',
                            top: 0,
                            display: 'flex',
                            alignItems: 'flex-end',
                        }}
                    >
                        <CircularProgress size={30} color="secondary" />
                    </div>
                )}
            </Box>
        </>
    );
};

export default UserAddress;
